import { jsx as _jsx } from "react/jsx-runtime";
import flagBelgium from "../../svg/flags/Flag-belgium.svg";
import { FlagImage } from "./FlagImage";
export const FlagBelgium = ({ ...props }) => (_jsx(FlagImage, { src: flagBelgium, alt: "Belgium", ...props }));
